import app from '@/app';
import templateUrl from './plan-result.html';

/* @ngInject */
function controller(
	$controller,
	$filter,
	$http,
	$httpParamSerializer,
	$rootScope,
	$state,
	$translate,
	DialogService,
	wfPivotUtils,
	wfPager2Service,
	PAGE_SIZES,
	SMALL_PAGE_SIZES,
	Principal
) {
	var $ctrl = this;

	$ctrl.finalMetric;
	$ctrl.currentAccount = null;

	Principal.identity().then(account => {
		$ctrl.currentAccount = account;
	});

	$ctrl.onChangeBeforeBuilt = function() {
		if ($ctrl.beforeBuilt && $ctrl.metric.indexOf('BEFORE_') == -1) {
			$ctrl.metric = 'BEFORE_' + $ctrl.metric;
		}
	};

	$controller('AbstractController', { $ctrl: $ctrl });

	function metricAggregator(metric) {
		return function() {
			return {
				data: null,
				push: function(record) {
					this.data = record[metric.name];
				},
				value: function() {
					return $filter('number')(this.data * metric.factor, metric.precision);
				}
			};
		};
	}

	function solutionAggregator() {
		return {
			solutions: null,
			missings: null,
			push: function(record) {
				this.missings = record['missingMeasurements'];
				// Tolerates a missing field (e.g. a row from another view): avoids breaking the $digest.
				this.solutions = (record['solutions'] || []).map(it => it.name);
			},
			isMissing: function() {
				return this.missings && this.missings.length > 0;
			},
			isSolution: function() {
				return this.solutions && this.solutions.length > 0;
			},
			value: function() {
				return (this.isMissing()
					? this.missings
					: this.isSolution()
					? this.solutions
					: []
				).join('+');
			},
			style: function() {
				return this.isMissing() ? 'error' : null;
			}
		};
	}

	//[US 111] Cálculo de materiais e quantidades (start)
	function materialsServicesAggregator() {
		return {
			materials: null,
			push: function(record) {
				this.materials = record['materialsServices'];
			},
			value: function() {
				// Tolerates a missing field: avoids a TypeError that would abort the $digest
				// (leaving the cells with the literal {{...}} template).
				return (this.materials || []).join('+');
			}
		};
	}
	//[US 111] (end)

	$ctrl.yearSizes = SMALL_PAGE_SIZES;
	$ctrl.segmentSizes = PAGE_SIZES;

	var transition = $ctrl.transition;
	$ctrl.transition = function(params) {
		transition(params);
		$ctrl.milestonePage = params.milestonePage != null ? parseInt(params.milestonePage) : 0;
		$ctrl.milestoneSize =
			params.milestoneSize != null ? parseInt(params.milestoneSize) : PAGE_SIZES[3];
		$ctrl.milestoneCount =
			1 +
			($ctrl.entity.tailMilestone - $ctrl.entity.headMilestone) / $ctrl.entity.segmentLength;

		const milestoneRange = wfPager2Service.createPage(
			$ctrl.milestonePage,
			$ctrl.milestoneSize,
			$ctrl.milestoneCount,
			$ctrl.entity.segmentLength,
			$ctrl.entity.headMilestone
		);
		$ctrl.headMilestone = milestoneRange.head;
		$ctrl.tailMilestone = milestoneRange.tail;

		$ctrl.yearPage = params.yearPage != null ? parseInt(params.yearPage) : 0;
		$ctrl.yearSize = params.yearSize != null ? parseInt(params.yearSize) : SMALL_PAGE_SIZES[0];
		$ctrl.yearCount = $ctrl.entity.processedYears;

		const yearRange = wfPager2Service.createPage(
			$ctrl.yearPage,
			$ctrl.yearSize,
			$ctrl.entity.processedYears,
			1,
			$ctrl.entity.headYear
		);
		$ctrl.headYear = yearRange.head;
		$ctrl.tailYear = yearRange.tail;

		$ctrl.direction = params.direction;
		$ctrl.lanes = params.lanes;
		$ctrl.metric = params.metric;
		$ctrl.beforeBuilt = params.beforeBuilt == 0 ? false : true;
		//[US 111] Cálculo de materiais e quantidades (start)
		$ctrl.showMaterialsServices = params.materialsServices == 0 ? false : true;
		//[US 111] (end)

		var i = $ctrl.options.cols.length;
		while (i--) {
			if (
				($ctrl.options.cols[i].name == 'sumCostKpiAllYears' ||
					$ctrl.options.cols[i].name == 'sumCostForYear') &&
				$ctrl.metric != 'KPI_COST'
			) {
				$ctrl.options.cols.splice(i, 1);
			}
		}

		var metric = $ctrl.metric && _.find({ code: $ctrl.metric })($ctrl.allMetrics);

		//[US 111] Cálculo de materiais e quantidades (start)
		if ($ctrl.showMaterialsServices) {
			$ctrl.options.aggregator = materialsServicesAggregator;
		} else if ($ctrl.metric && $ctrl.metric == 'KPI_MATERIALS_SERVICES') {
			$ctrl.options.aggregator = materialsServicesAggregator;
		} else {
			$ctrl.options.aggregator = $ctrl.metric ? metricAggregator(metric) : solutionAggregator;
		}
		//[US 111] (end)

		$ctrl.road = $ctrl.entity.road.name;
		$ctrl.campaign = $ctrl.entity.campaign.name;

		const query = _.pick([
			'headMilestone',
			'tailMilestone',
			'headYear',
			'tailYear',
			'direction',
			'lanes',
			'metric',
			'road',
			'campaign'
		])($ctrl);

		// Tells the backend which aggregator the screen uses, so /results projects
		// only the consumed column (materials, scalar metric or solutions).
		query.materialsServices = $ctrl.showMaterialsServices ? 1 : 0;

		$ctrl.exportLinkFullKPI =
			'/api/plans/' + $ctrl.entity.id + '/results/full/excel?' + $httpParamSerializer(query);

		$ctrl.exportLink =
			'/api/plans/' + $ctrl.entity.id + '/results/excel?' +
			$httpParamSerializer(Object.assign({ reportName: 'resultado_planejamento' }, query));

		$ctrl.isExporting = false;

		$ctrl.downloadExcel = function(url) {
			$ctrl.isExporting = true;
			DialogService.alertMessage($translate.instant('action.exportDownloading'));
			$http.get(url, { responseType: 'blob' })
				.then(function(response) {
					var blob = new Blob([response.data], {
						type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
					});
					var link = document.createElement('a');
					link.href = URL.createObjectURL(blob);
					var cd = response.headers('content-disposition');
					link.download = cd ? cd.split('filename=')[1].replace(/^[\s'";]+|[\s'";]+$/g, '') : 'export.xlsx';
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					URL.revokeObjectURL(link.href);
				})
				.catch(function() {
					DialogService.alertMessage($translate.instant('action.exportError'));
				})
				.finally(function() {
					$ctrl.isExporting = false;
				});
		};

		// Keeps the global loading overlay active during the heavy results fetch:
		// this fetch runs in $onInit, after the UI-Router onSuccess already cleared
		// isTransitioning, so without this flag the spinner disappears before the
		// table loads. Cleared in finally (success or error).
		$ctrl.isSearching = true;
		$rootScope.isLoadingResults = true;
		$http
			.get('api/plans/' + $ctrl.entity.id + '/results', { params: query })
			.then(function(response) {
				$ctrl.entities = response.data;
			})
			.finally(function() {
				$ctrl.isSearching = false;
				$rootScope.isLoadingResults = false;
			});

		if ($ctrl.beforeBuilt && $ctrl.metric.indexOf('BEFORE_') !== -1) {
			$ctrl.metric = params.metric.replace('BEFORE_', '');
		}

		if ($ctrl.showMaterialsServices) {
			$http
				.get('api/plans/materialservicesummaries/' + $ctrl.entity.id)
				.then(function(response) {
					$ctrl.materialservicesummaries = response.data;
				});
		}

		$ctrl.allMetrics = $ctrl.allMetrics.filter(item => item.code.indexOf('BEFORE_') == -1);
	};

	$ctrl.options = {
		formatter: wfPivotUtils.formatters.asis(),
		rows: [
			{
				name: 'headMilestone',
				translation: 'common.headMilestone',
				formatter: wfPivotUtils.formatters.number(3)
			},
			{
				name: 'tailMilestone',
				translation: 'common.tailMilestone',
				formatter: wfPivotUtils.formatters.number(3)
			}
		],
		cols: [
			{
				name: 'sumCostKpiAllYears',
				translation: 'name.totalAllYear',
				formatter: wfPivotUtils.formatters.number(3)
			},
			{
				name: 'year',
				translation: 'common.year'
			},
			{
				name: 'sumCostForYear',
				translation: 'name.totalForYear',
				formatter: wfPivotUtils.formatters.number(3)
			},
			{
				name: 'direction',
				translation: 'common.direction',
				sorter: wfPivotUtils.sorters.sortAs(['DEC', 'INC']),
				formatter: direction => $translate.instant('direction.' + direction)
			},
			{
				name: 'lane',
				translation: 'common.lane',
				formatter: lane => {
					const val = Math.abs(lane);
					return val == 100 ? 'acost' : val;
				}
			}
		]
	};

	$ctrl.filterLane = function(lane) {
		return $ctrl.lanes || !_.includes(lane)($ctrl.lanes);
	};

	$ctrl.toggleMaterialsServices = function() {
		var metric = $ctrl.metric && _.find({ code: $ctrl.metric })($ctrl.allMetrics);
		var aggregator = $ctrl.showMaterialsServices
			? materialsServicesAggregator
			: ($ctrl.metric ? metricAggregator(metric) : solutionAggregator);
		$ctrl.options = Object.assign({}, $ctrl.options, { aggregator: aggregator });
	};

	/* ----------------------------------------------------------
	 * DEBOUNCE MANUAL (setTimeout) AQUI
	 * ---------------------------------------------------------- */
	let onQueryTimeout = null;

	$ctrl.onQueryChange = function(query) {
		if (onQueryTimeout) {
			clearTimeout(onQueryTimeout);
		}

		onQueryTimeout = setTimeout(() => {
			if ($ctrl.beforeBuilt && $ctrl.metric.indexOf('BEFORE_') == -1) {
				$ctrl.metric = 'BEFORE_' + $ctrl.metric;
			}

			$state.go(
				$state.current,
				{
					milestonePage: $ctrl.milestonePage,
					milestoneSize: $ctrl.milestoneSize,
					yearPage: $ctrl.yearPage,
					yearSize: $ctrl.yearSize,
					direction: $ctrl.direction,
					lanes: $ctrl.lanes,
					metric: $ctrl.metric,
					beforeBuilt: $ctrl.beforeBuilt ? 1 : 0
				},
				{ reload: true }
			);
		}, 400);
	};

	$ctrl.onMilestonePageChange = function(page, size) {
		$state.go(
			$state.current,
			{ milestonePage: page, milestoneSize: size, materialsServices: $ctrl.showMaterialsServices ? 1 : 0 },
			{ reload: true }
		);
	};

	$ctrl.onYearPageChange = function(page, size) {
		$state.go(
			$state.current,
			{ yearPage: page, yearSize: size, materialsServices: $ctrl.showMaterialsServices ? 1 : 0 },
			{ reload: true }
		);
	};
}

const component = {
	templateUrl,
	controller,
	bindings: {
		$transition$: '<',
		allMetrics: '<',
		entity: '<'
	}
};

app.component('planResult', component);